interface CheckedBox {
  created: boolean
  description?: string
  id: number
  isData: boolean
  isOperator: boolean
  key: string
  label: string
  operator: string
  search: string[]
  show: boolean
  show_sitio: boolean
  value: number
}

interface Var {
  description?: string
  show: boolean
  show_sitio: boolean
  value: number
  label: string
}
interface Payload {
  var: Var
}

export const isInCheckedBoxList = (checkedBox: CheckedBox[], key: string): boolean =>
  checkedBox.find((item) => item.key === key) ? true : false

export const isLabelInCheckedBoxList = (checkedBox: CheckedBox[], label: string): boolean =>
  checkedBox.find((item) => item.label === label) ? true : false

export const deleteItemInCheckedBoxList = (checkedBox: CheckedBox[], key: string): CheckedBox[] | [] =>
  checkedBox.filter((item) => item.key !== key)

export const updateItemInCheckBoxList = (
  checkedBox: CheckedBox[],
  key: string,
  payload: Payload
): CheckedBox[] => {
  return checkedBox.map((item) => {
    const updatedSearch = item.search.map((searchItem) =>
      searchItem === item.label ? payload.var.label : searchItem
    )
    return item.key === key ? { ...item, ...payload.var, search: updatedSearch } : item
  })
}
